module.exports = __webpack_public_path__ + "site/img/20.392afa04.jpg";